import { Component, input } from '@angular/core';
import type { TKlankvoetRule } from '../rid-klankvoet-rule-modal/rid-klankvoet-rule-modal';

/** The schematic split notation for a klankvoet rule (e.g. `_ / ■`). Takes its color from `currentColor`. */
@Component({
  selector: 'rid-klankvoet-rule-glyph',
  templateUrl: './rid-klankvoet-rule-glyph.html',
  host: {
    class: 'flex justify-center',
  },
})
export class RidKlankvoetRuleGlyph {
  rule = input.required<TKlankvoetRule>();
}
